export default "/ui/assets/icons/caret-language-picker.svg";